import React, { Component } from 'react';
import Modal from 'react-modal';

import './modal.css';

Modal.setAppElement(document.getElementById('root'));

class ModalMain extends Component {
    render() {
        const { children, title, style = {},isOpen, onClose, className, overlayClassName='' } = this.props;
        return (
            <div>
                <Modal isOpen={isOpen} style={style} className={className} overlayClassName={overlayClassName}> 
                    <header className='headerModal'>
                        <h2 >{title}</h2> 

                        <button onClick={onClose}>x</button>
                    </header>
                    {children}
                </Modal>
            </div >
        );
    }
}

export default ModalMain;


// WEBPACK FOOTER //
// ./src/App/components/modal/modal.js